<template>
  <div id="saas_platforms">
    <div class="header">
      <div class="left">
        <img :src="require('../assets/images/' + list.img)" />
      </div>
      <div class="right">
        <!-- <label for="Sass Platforms">{{ list.name }}</label> -->
        <label for="Sass Platforms">案例展示</label>
      </div>
    </div>
    <!-- <div class="text">
      <div class="layout-content">{{ list.titles }}</div>
    </div> -->
    <div class="case-layout-1">
      <div class="left">
        <img :src="require('../assets/images/' + $t('details')[0].img)" />
      </div>
      <div class="right">
        <label class="title">{{ $t('details')[0].title }}</label>
        <div class="content">{{ $t('details')[0].str }}</div>
      </div>
    </div>
    <div class="case-layout-2">
      <div class="left">
        <label class="title">{{ $t('details')[1].title }}</label>
        <div class="content">{{ $t('details')[1].str }}</div>
      </div>
      <div class="right">
        <img :src="require('../assets/images/' + $t('details')[1].img)" />
      </div>
    </div>
    <div class="case-layout-1">
      <div class="left">
        <img :src="require('../assets/images/' + $t('details')[2].img)" />
      </div>
      <div class="right">
        <label class="title">{{ $t('details')[2].title }}</label>
        <div class="content">{{ $t('details')[2].str }}</div>
      </div>
    </div>
    <div class="case-layout-2">
      <div class="left">
        <label class="title">{{ $t('details')[3].title }}</label>
        <div class="content">{{ $t('details')[3].str }}</div>
      </div>
      <div class="right">
        <img :src="require('../assets/images/' + $t('details')[3].img)" />
      </div>
    </div>
    <div class="case-layout-1">
      <div class="left">
        <img :src="require('../assets/images/' + $t('details')[4].img)" />
      </div>
      <div class="right">
        <label class="title">{{ $t('details')[4].title }}</label>
        <div class="content">{{ $t('details')[4].str }}</div>
      </div>
    </div>
    <div class="case-layout-2">
      <div class="left">
        <label class="title">{{ $t('details')[5].title }}</label>
        <div class="content">{{ $t('details')[5].str }}</div>
      </div>
      <div class="right">
        <img :src="require('../assets/images/' + $t('details')[5].img)" />
      </div>
    </div>
    <div class="case-layout-1">
      <div class="left">
        <img :src="require('../assets/images/' + $t('details')[6].img)" />
      </div>
      <div class="right">
        <label class="title">{{ $t('details')[6].title }}</label>
        <div class="content">{{ $t('details')[6].str }}</div>
      </div>
    </div>
    <div class="case-layout-2">
      <div class="left">
        <label class="title">{{ $t('details')[7].title }}</label>
        <div class="content">{{ $t('details')[7].str }}</div>
      </div>
      <div class="right">
        <img :src="require('../assets/images/' + $t('details')[7].img)" />
      </div>
    </div>
    <div class="case-layout-1">
      <div class="left">
        <img :src="require('../assets/images/' + $t('details')[8].img)" />
      </div>
      <div class="right">
        <label class="title">{{ $t('details')[8].title }}</label>
        <div class="content">{{ $t('details')[8].str }}</div>
      </div>
    </div>
    <div class="case-layout-2">
      <div class="left">
        <label class="title">{{ $t('details')[9].title }}</label>
        <div class="content">{{ $t('details')[9].str }}</div>
      </div>
      <div class="right" style="height:500px;">
        <img :src="require('../assets/images/' + $t('details')[9].img)" />
      </div>
    </div>
    <div class="case-layout-1">
      <div class="left">
        <img :src="require('../assets/images/' + $t('details')[10].img)" />
      </div>
      <div class="right">
        <label class="title">{{ $t('details')[10].title }}</label>
        <div class="content">{{ $t('details')[10].str }}</div>
      </div>
    </div>
    <!-- <div class="case-layout-2">
      <div class="left">
        <label class="title">{{ list.data[1].title }}</label>
        <div class="content">{{ list.data[1].str }}</div>
      </div>
      <div class="right">
        <img :src="require('../assets/images/' + list.data[1].imgs)" />
      </div>
    </div>
    <div class="case-layout-1" style="padding-bottom:150px">
      <div class="left">
        <img :src="require('../assets/images/' + list.data[2].imgs)" />
      </div>
      <div class="right">
        <label class="title">{{ list.data[2].title }}</label>
        <div class="content">{{ list.data[2].str }}</div>
      </div>
    </div> -->
    <div class="contact-us">
      <div class="icon">
        <van-icon name="like-o" color="#FFFFFF" size="1px" />
      </div>
      <!-- <label>{{ list.like }}</label> -->
      <label>{{ $t('common').phone }}</label>
      <label>{{ $t('contact.address') }}</label>
      <label>{{ $t('contact.email') }}</label>
      <van-button class="btn" color="#FFFFFF" round size="large" @click="onContact">
        Contact Us
      </van-button>
    </div>
    <Dialog ref="dialog"></Dialog>
  </div>
</template>
<script>
  import Bus from '../bus'
  import { Button } from 'vant'
  import { Icon } from 'vant'
  import Dialog from '@/components/dialog.vue'
  export default {
    name: 'saas_platforms',
    components: {
      [Button.name]: Button,
      [Icon.name]: Icon,
      Dialog,
    },
    data() {
      return {
        list: [],
        flag: false,
        num: Number(),
      }
    },
    created() {
      //根据状态选择渲染数据false为中文，true为英文
      this.setData()
      Bus.$off('flag') //解除bus，防止重复渲染
      Bus.$on('flag', () => {
        this.setData()
      })
    },
    methods: {
      setData() {
        this.list = this.$t('data').find((x) => x.sign === this.$route.query.name)
      },
      onContact() {
        this.$refs.dialog.show()
      },
    },
  }
</script>
<style scoped lang="scss">
  #saas_platforms {
    font-size: 26px;
    .layout-content {
      display: flex;
      flex: 0 0 90%;
    }
    .header {
      width: 100%;
      height: auto;
      display: flex;
      background: #7d7d7d;
      .left {
        display: flex;
        flex: 0 0 40%;
      }
      .right {
        flex: 0 0 60%;
        position: relative;
        label {
          position: absolute;
          top: 30%;
          left: 5%;
          color: #f9f9f9;
          font-size: 42px;
          font-weight: bold;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      background: #f9f9f9;
      padding: 30px;
      color: #4d4d4d;
      text-align: center;
      display: flex;
      justify-content: center;
    }

    .case-layout-1 {
      padding: 50px 30px;
      background: #4c4c4c;
      color: #ffffff;
      display: flex;
      justify-content: center;
      .left {
        display: flex;
        flex: 0 0 55%;
        padding: 0 30px;
        // height: 600px;
      }
      .right {
        display: flex;
        flex: 0 0 35%;
        flex-direction: column;
        font-size: 32px;
        margin-top: 70px;
        .title {
          padding: 20px 0;
          text-decoration: underline;
        }
        .content {
          font-size: 26px;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .case-layout-2 {
      padding: 50px 30px;
      color: #4c4c4c;
      display: flex;
      justify-content: center;
      .left {
        display: flex;
        flex: 0 0 35%;
        flex-direction: column;
        margin-top: 70px;
        .title {
          padding: 20px 0;
          font-size: 32px;
          text-decoration: underline;
        }
        .content {
          font-size: 26px;
        }
      }
      .right {
        display: flex;
        flex: 0 0 55%;
        padding: 0 30px;
        // height: 600px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }

    .contact-us {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #e2565d;
      height: 320px;
      position: relative;
      .icon {
        width: 200px;
        height: 200px;
        border-radius: 50%;
        background: #e2565d;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: -100px;
      }
      label {
        color: #ffffff;
        font-size: 24px;
        &:first-of-type {
          margin-top: 100px;
        }
      }
      .btn {
        width: 438px;
        color: #e2565d !important;
        font-size: 20px;
        font-weight: bold;
        margin: 30px auto;
      }
    }
  }
</style>
